// Financiamiento Solo LD HomeBanking PF
export const GTM_CODE_DEV = 'GTM-M973827';
export const GTM_CODE_PROD = 'GTM-T47852Z';

export const PAGEVIEW = {
  siteChannelWeb: {
    path: 'site.channel',
    value: 'HomeBankingPF',
  },
  siteChannelApp: {
    path: 'site.channel',
    value: 'SuperAppPF',
  },
  developmenttype: {
    path: 'site.developmenttype',
    value: 'Web',
  },
  environment: {
    path: 'site.environment',
    value: null,
  },
  useragent: {
    path: 'site.useragent',
    value: null,
  },
  permissions: {
    path: 'site.permissions',
    value: null,
  },
  accessibility: {
    path: 'site.accessibility',
    value: null,
  },
  geolocation: {
    path: 'visitor.geolocation',
    value: 'NotAvailable',
  },
  clientIdpf: {
    path: 'visitor.client.idpf',
    value: null,
  },

  // Pantallas de Financiamiento Solo LD
  // Pantalla 1
  pv1pageName: {
    path: 'page.name',
    value: 'ValidacionPEP',
  },
  pv1pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv1subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv1pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv1pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv1internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv1errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv1transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv1transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Identificacion',
  },

  // Pantalla 2
  pv2pageName: {
    path: 'page.name',
    value: 'SolicitudOTP',
  },
  pv2pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv2subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv2pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv2pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv2internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv2errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv2transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv2transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Identificacion',
  },

  // Pantalla 3
  pv3pageName: {
    path: 'page.name',
    value: 'CondicionesAsegurabilidad',
  },
  pv3pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv3subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv3pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv3pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv3internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv3errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv3transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv3transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Captura',
  },

  // Pantalla 4
  pv4pageName: {
    path: 'page.name',
    value: 'OcupacionActual',
  },
  pv4pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv4subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv4pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv4pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv4internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv4errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv4transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv4transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Captura',
  },

  // Pantalla 5
  pv5pageName: {
    path: 'page.name',
    value: 'ActualizacionDatosOpcional',
  },
  pv5pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv5subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv5pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv5pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv5internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv5errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv5transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv5transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'CapturaDatosOpcional',
  },

  // Pantalla 6
  pv6pageName: {
    path: 'page.name',
    value: 'DatosDesactualizados',
  },
  pv6pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv6subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv6pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv6pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv6internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv6errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv6transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv6transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'CapturaDatosDesactualizados',
  },

  // Pantalla 7
  pv7pageName: {
    path: 'page.name',
    value: 'ActualizacionDatosCambioOcupacion',
  },
  pv7pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv7subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv7pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv7pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv7internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv7errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv7transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv7transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'CapturaCambioOcupacion',
  },

  // Pantalla 8
  pv8pageName: {
    path: 'page.name',
    value: 'YaCasiTerminamos',
  },
  pv8pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv8subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv8pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv8pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv8internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv8errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv8transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv8transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Configuracion',
  },

  // Pantalla 9
  pv9pageName: {
    path: 'page.name',
    value: 'FechaPagoLD',
  },
  pv9pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv9subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv9pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv9pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv9internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv9errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv9transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv9transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Configuracion',
  },

  // Pantalla 10
  pv10pageName: {
    path: 'page.name',
    value: 'SeleccionCuenta',
  },
  pv10pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv10subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv10pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv10pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv10internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv10errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv10transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv10transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'ConfiguracionConCuenta',
  },

  // Pantalla 11
  pv11pageName: {
    path: 'page.name',
    value: 'AperturaCuenta',
  },
  pv11pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv11subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv11pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv11pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv11internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv11errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv11transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv11transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'ConfiguracionSinCuenta',
  },

  // Pantalla 12
  pv12pageName: {
    path: 'page.name',
    value: 'ConfirmacionCelular',
  },
  pv12pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv12subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv12pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv12pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv12internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv12errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv12transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv12transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'ConfiguracionSinCuenta',
  },

  // Pantalla 13
  pv13pageName: {
    path: 'page.name',
    value: 'AcompañamientoAsesor',
  },
  pv13pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv13subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv13pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv13pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv13internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv13errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv13transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv13transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Configuracion',
  },

  // Pantalla 14
  pv14pageName: {
    path: 'page.name',
    value: 'Vinculacion',
  },
  pv14pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv14subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv14pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv14pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv14internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv14errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv14transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv14transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Vinculacion',
  },

  // Pantalla 15
  pv15pageName: {
    path: 'page.name',
    value: 'VinculacionCreacionProducto',
  },
  pv15pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv15subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv15pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv15pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv15internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv15errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv15transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv15transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: 'Vinculacion',
  },

  // Pantalla 16
  pv16pageName: {
    path: 'page.name',
    value: 'AlgoSalioMal',
  },
  pv16pageFamily: {
    path: 'page.family',
    value: 'Servicios',
  },
  pv16subFamily: {
    path: 'page.subfamily',
    value: 'Solicitud',
  },
  pv16pageAction: {
    path: 'page.action',
    value: 'Solicitar',
  },
  pv16pageid: {
    path: 'page.pageid',
    value: null,
  },
  pv16internaltracking: {
    path: 'custom.internaltracking',
    value: null,
  },
  pv16errorname: {
    path: 'custom.errorname',
    value: null,
  },
  pv16transactionName: {
    path: 'transaction.name',
    value: 'CampañaAprobadosSoloLD',
  },
  pv16transactionTransactionStep: {
    path: 'transaction.details.transactionstep',
    value: null,
  },

};

export const EVENT = {
  customCategory: {
    module: {
      body: 'Body',
      carousel: 'Carousel',
      footer: 'Footer',
      header: 'Header',
      lightbox: 'Lightbox',
      menu: 'Menu',
    },
    type: {
      accordion: 'Accordion',
      arrow: 'Arrow',
      button: 'Button',
      card: 'Card',
      checkbox: 'Checkbox',
      dropdown: 'Dropdown',
      image: 'Image',
      link: 'Link',
      pagination: 'Pagination',
      radio: 'Radio',
      tab: 'Tab',
      textField: 'TextField',
      tooltip: 'Tooltip',
      warning: 'Warning',
    },
    position: {
      bottom: 'Bottom',
      center: 'Center',
      left: 'Left',
      rigt: 'Right',
      top: 'Top',
    },
  },
  customAction: {
    click: 'Click',
    close: 'Close',
    download: 'Download',
    hide: 'Hide',
    open: 'Open',
    print: 'Print',
    scroll: 'Scroll',
    search: 'Search',
    share: 'Share',
    show: 'Show',
    swipeToLeft: 'SwipeToLeft',
    swipeToRigth: 'SwipeToRigth',
  },

  // Pantallas de Financiamiento Solo LD

  // Eventos transversales Salir
  E1customLabel: 'Salir',
  E1setData: {
    E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: null,
    },
  },

  // Eventos Pantalla 1
  pv1E2customLabel: 'Volver',
  pv1E2setData: {
    pv1E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv1E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Identificacion',
    },
  },
  pv1E3customLabel: 'Continuar',
  pv1E3setData: {
    pv1E3transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv1E3transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Identificacion',
    },
    pv1E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },

  // Eventos Pantalla 2
  pv2E1customLabel: 'Volver',
  pv2E1setData: {
    pv2E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv2E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Identificacion',
    },
  },
  pv2E2customLabel: 'Validar',
  pv2E2setData: {
    pv2E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv2E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Identificacion',
    },
  },
  pv2E3customLabel: 'ReenviarCodigo',
  pv2E3setData: {
    pv2E3transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv2E3transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Identificacion',
    },
  },
  pv2E4customLabel: 'TengoProblemas',
  pv2E4setData: {
    pv2E4transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv2E4transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Identificacion',
    },
  },

  // Eventos Pantalla 3
  pv3E1customLabel: 'Volver',
  pv3E1setData: {
    pv3E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv3E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Captura',
    },
  },
  pv3E2customLabel: 'Continuar',
  pv3E2setData: {
    pv3E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv3E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Captura',
    },
    pv3E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },

  // Eventos Pantalla 4
  pv4E1customLabel: 'Volver',
  pv4E1setData: {
    pv4E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv4E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Captura',
    },
  },
  pv4E2customLabel: 'Continuar',
  pv4E2setData: {
    pv4E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv4E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Captura',
    },
    pv4E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },

  // Eventos Pantalla 5
  pv5E1customLabel: 'Si',
  pv5E1setData: {
    pv5E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv5E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'CapturaDatosOpcional',
    },
  },
  pv5E2customLabel: 'No',
  pv5E2setData: {
    pv5E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv5E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'CapturaDatosOpcional',
    },
  },

  // Eventos Pantalla 9
  pv9E1customLabel: 'Volver',
  pv9E1setData: {
    pv9E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv9E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Configuracion',
    },
  },
  pv9E2customLabel: 'Continuar',
  pv9E2setData: {
    pv9E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv9E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Configuracion',
    },
  },

  // Eventos Pantalla 10
  pv10E1customLabel: 'Volver',
  pv10E1setData: {
    pv10E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv10E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'ConfiguracionConCuenta',
    },
  },
  pv10E2customLabel: 'Aceptar',
  pv10E2setData: {
    pv10E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv10E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'ConfiguracionConCuenta',
    },
  },

  // Eventos Pantalla 11
  pv11E1customLabel: 'Volver',
  pv11E1setData: {
    pv11E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv11E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'ConfiguracionSinCuenta',
    },
  },
  pv11E2customLabel: 'Aceptar',
  pv11E2setData: {
    pv11E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv11E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'ConfiguracionSinCuenta',
    },
  },

  // Eventos Pantalla 12
  pv12E1customLabel: 'Volver',
  pv12E1setData: {
    pv12E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv12E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'ConfiguracionSinCuenta',
    },
  },
  pv12E2customLabel: 'Continuar',
  pv12E2setData: {
    pv12E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv12E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'ConfiguracionSinCuenta',
    },
  },

  // Eventos Pantalla 13
  pv13E1customLabel: 'Volver',
  pv13E1setData: {
    pv13E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv13E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Configuracion',
    },
  },
  pv13E2customLabel: 'Continuar',
  pv13E2setData: {
    pv13E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv13E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Configuracion',
    },
    pv13E3clientElegibility: {
      path: 'visitor.client.elegibility',
      value: null,
    },
  },

  // Eventos Pantalla 14
  pv14E1customLabel: 'Volver',
  pv14E1setData: {
    pv14E1transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv14E1transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Vinculacion',
    },
  },
  pv14E2customLabel: 'Solicitar',
  pv14E2setData: {
    pv14E2transactionName: {
      path: 'transaction.name',
      value: 'CampañaAprobadosSoloLD',
    },
    pv14E2transactionTransactionStep: {
      path: 'transaction.details.transactionstep',
      value: 'Vinculacion',
    },
  },

};
export const COUNTRY = {
  ar: 'AR',
  cl: 'CL',
  co: 'CO',
  oca: 'OCA',
  py: 'PY',
  uy: 'UY',
};

export const BUSINNESS = {
  pf: 'PF',
  pj: 'PJ',
  un: 'UN',
};

export const ENVIRONMENT = {
  loggeado: 'LG',
  noLoggeado: 'NL',
};

export const CHANNEL = {
  apppn: 'APN',
  superapp: 'SA',
  apptarjetas: 'AT',
  homeBanking: 'HB',
  abreCuentas: 'AC',

};

export const FAMILY = {
  commonArea: 'AreaComun',
  care: 'Atendimento',
  campaigns: 'Campanas',
  accounts: 'Cuentas',
  fidelity: 'Fidelidad',
  investments: 'Seguros',
  payment: 'Pagamentos',
  loan: 'Prestamo',
  insurance: 'Seguros',
  services: 'Servicios',
  cards: 'Tarjetas',
  transfers: 'Transferencias',
};

export const SUBFAMILY = {
  personalAccidents: 'AccidentesPersonales',
  aguinaldoAdvance: 'AdelantoAguinaldo',
  customs: 'Aduana',
  savingsForecast: 'AhorroPrevisionalUdutario',
  savingsScheduled: 'AhorroProgramado',
  feed: 'Alimentacion',
  proxies: 'Apoderados',
  automotive: 'Automotores',
  help: 'Ayuda',
  banksLocais: 'BancosLocais',
  basic: 'Basica',
  beneficiaries: 'Beneficiarios',
  profiLDards: 'BeneficioTarjetas',
  boxSavings: 'CajaAhorro',
  juniorSavingsBox: 'CajaAhorroJunior',
  cashiers: 'Cajeros',
  change: 'Cambio',
  captureDocument: 'CapturaDocumento',
  certification: 'Certificacion',
  chat: 'Chat',
  checks: 'Cheques',
  checksFanfold: 'ChequesFanfold',
  tradeExterior: 'ComercioExterior',
  configurationLinking: 'ConfiguracionVinculacion',
  foreignCurrency: 'CorrienteMonedaExtranjera',
  LocalCurrencyStream: 'CorrienteMonedaLocal',
  credit: 'Credito',
  ownAccounts: 'CuentasPropias',
  virtualAccounts: 'CuentasVirtuales',
  debitoAutomatico: 'DebitoAutomatico',
  depositsTermFixed: 'DepositosPlazoFijo',
  digitization: 'Digitalizacion',
  outside: 'Dxterior',
  bill: 'Factura',
  faq: 'FAQ',
  finance: 'Finanzas',
  fonasa: 'Fonasa',
  funds: 'Productos',
  form: 'Formulario',
  formInitial: 'FormularioInicial',
  turnsIEDE: 'GirosIEDE',
  datacontact: 'DatosContacto',
  mortgage: 'Hipotecarios',
  historicYTaxasCommissions: 'HistoricoComisionesYTaxas',
  HistoricOfUnderstandings: 'HistoricoDeComprovantes',
  home: 'Home',
  incomedata: 'IngresoDatos',
  irpf: 'IRPF',
  itau: 'Itau',
  landingPage: 'LandingPage',
  letterChange: 'LetraDeCambio',
  letterOfRegulation: 'LetrasDeRegulacionMonetaria',
  linkChannelYoutube: 'LinkCanalYoutube',
  limit: 'Limite',
  creditline: 'LineaDeCredito',
  login: 'Login',
  movements: 'Movimientos',
  notification: 'Notificacion',
  offerProducts: 'OfertaProductos',
  paymentsSMS: 'PagosSMS',
  shareholdingInCertificateOfDeposit: 'ParticipacionEnCertificadoDeDeposito',
  finalStep: 'PasoFinal',
  riskProfile: 'PerfilDeRiesgo',
  personal: 'Personales',
  pld: 'PLD',
  preapproved: 'Preaprobado',
  products: 'Productos',
  proposta: 'Proposta',
  promotions: 'Promociones',
  points: 'Puntos',
  recharge: 'Recarga',
  rechargeable: 'Recargable',
  fundraising: 'Recaudadoras',
  registration: 'Registro',
  health: 'Salud',
  security: 'Seguridad',
  self: 'Self',
  services: 'Seguros',
  overdraft: 'Sobregiro',
  request: 'Solicitud',
  surcursales: 'Surcursales',
  tariff: 'Tarifario',
  cards: 'Tarjetas',
  card: 'TarjetaDebito',
  tolls: 'Telepeaje',
  typechange: 'TipoCambio',
  titleWithSectiones: 'TituloConsecciones',
  travel: 'Viajes',
  life: 'Vida',
  view: 'Vista',
  wallet: 'Wallet',
};

export const PRODUCT = {
  open: 'Abrir',
  activate: 'Activar',
  add: 'Agregar',
  schedule: 'Agendar',
  block: 'Bloquear ',
  change: 'Cambiar',
  cancel: 'Cancelar',
  redeem: 'Canjear',
  consult: 'Consultar',
  configure: 'Configurar',
  hire: 'Contratar',
  disable: 'Desabilitar',
  address: 'Direccionar',
  edit: 'Editar',
  remove: 'Eliminar',
  enable: 'Habilitar',
  log: 'Loguear',
  pay: 'Pagar',
  rescue: 'Rescatar',
  recharge: 'Recargar',
  request: 'Solicitar',
  offer: 'Ofertar',
  transfe: 'Transferir',
};
